import types from '../../../realEstateTypes.js';
import geoHierarchyLevels from '../../../geoHierarchyLevels';

const TYPE_CONFIG = {
  [types.HOUSE_BUY]: {
    title: () => 'Entwicklung der Kaufpreise für Häuser',
    subTitle: ({ address }) =>
      `auf Basis durchschnittlicher, historischer Angebotspreise für Häuser in ${address} und Umgebung.`,
  },
  [types.HOUSE_RENT]: {
    title: () => 'Entwicklung der Mietpreise für Häuser',
    subTitle: ({ address }) =>
      `auf Basis durchschnittlicher, historischer Angebotspreise für Häuser in ${address} und Umgebung.`,
  },
  [types.APARTMENT_BUY]: {
    title: () => 'Entwicklung der Kaufpreise für Wohnungen',
    subTitle: ({ address }) =>
      `auf Basis durchschnittlicher, historischer Angebotspreise für Eigentumswohnungen in ${address} und Umgebung.`,
  },
  [types.APARTMENT_RENT]: {
    title: () => 'Entwicklung der Mietpreise für Wohnungen',
    subTitle: ({ address }) =>
      `auf Basis durchschnittlicher, historischer Angebotspreise für Eigentumswohnungen in ${address} und Umgebung.`,
  },
};

const TYPE_CONFIG_SEO = {
  [types.HOUSE_BUY]: {
    title: ({ address }) => `Kaufpreisentwicklung für Häuser in ${address}`,
    subTitle: ({ address }) =>
      `auf Basis durchschnittlicher, historischer Angebotspreise für Häuser in ${address} und Umgebung.`,
  },
  [types.HOUSE_RENT]: {
    title: ({ address }) => `Mietpreisentwicklung für Häuser in ${address}`,
    subTitle: ({ address }) =>
      `auf Basis durchschnittlicher, historischer Angebotspreise für Häuser in ${address} und Umgebung.`,
  },
  [types.APARTMENT_BUY]: {
    title: ({ address }) => `Kaufpreisentwicklung für Wohnungen in ${address}`,
    subTitle: ({ address }) =>
      `auf Basis durchschnittlicher, historischer Angebotspreise für Eigentumswohnungen in ${address} und Umgebung.`,
  },
  [types.APARTMENT_RENT]: {
    title: ({ address }) => `Mietpreisentwicklung für Wohnungen in ${address}`,
    subTitle: ({ address }) =>
      `auf Basis durchschnittlicher, historischer Angebotspreise für Eigentumswohnungen in ${address} und Umgebung.`,
  },
};

function getFor(realEstateType, hierarchyLevel) {
  if (hierarchyLevel === geoHierarchyLevels.ADDRESS || hierarchyLevel === geoHierarchyLevels.STREET) {
    return TYPE_CONFIG[realEstateType] || TYPE_CONFIG[types.HOUSE_BUY];
  }
  return TYPE_CONFIG_SEO[realEstateType] || TYPE_CONFIG[types.HOUSE_BUY];
}

export default {
  getFor,
};
